<template><DashboardPanel title="报修类型分布" meta="单位：单"><div class="repair-type"><div ref="bars" class="repair-type__bars"></div><div class="repair-type__trend"><div>近7日趋势（单）</div><div ref="trend" class="repair-type__line"></div></div></div></DashboardPanel></template>
<script>
import * as echarts from 'echarts'
import DashboardPanel from './DashboardPanel.vue'
import { axisScale, dashboardTooltip, formatNumber, formatPercent, toNumber } from '../dashboardFormat'

export default {
  name: 'RepairType',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  data: () => ({ charts: [] }),
  computed: {
    types() {
      const rows = Array.isArray(this.data.breakdown) ? this.data.breakdown : []
      return rows.reduce((result, row) => {
        const key = row.repairType || 'unknown'
        const existing = result.find(item => item.key === key)
        if (existing) {
          existing.value += toNumber(row.repairCount)
        } else {
          result.push({ key, name: row.repairTypeName || `类型 ${key}`, value: toNumber(row.repairCount) })
        }
        return result
      }, []).sort((a, b) => b.value - a.value).slice(0, 5)
    },
    trendRows() { return Array.isArray(this.data.trend) ? this.data.trend : [] }
  },
  watch: { data: { deep: true, handler() { this.renderCharts() } } },
  mounted() {
    this.renderCharts()
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    this.disposeCharts()
  },
  methods: {
    renderCharts() {
      if (!this.$refs.bars || !this.$refs.trend) return
      this.disposeCharts()
      const bars = echarts.init(this.$refs.bars)
      const trend = echarts.init(this.$refs.trend)
      const total = this.types.reduce((sum, item) => sum + item.value, 0)
      const values = this.types.map(item => item.value)
      const max = Math.max.apply(null, values.concat([1]))
      bars.setOption({
        grid: { top: 4, right: 72, bottom: 6, left: 61 },
        tooltip: dashboardTooltip({
          trigger: 'item',
          formatter: params => `${params.marker}${echarts.format.encodeHTML(params.name)}<br/>工单数：${formatNumber(params.value)} 单<br/>占比：${formatPercent(params.value, total)}`
        }),
        xAxis: { type: 'value', show: false, max: Math.ceil(max / 50) * 50 || 50 },
        yAxis: { type: 'category', inverse: true, data: this.types.map(item => item.name), axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: '#b7c8d4', fontSize: 11 } },
        series: [{ name: '工单数', type: 'bar', barWidth: 10, data: values, itemStyle: { color: '#4096ef' }, label: { show: true, position: 'right', color: '#aebfca', fontSize: 9, formatter: params => `${formatNumber(params.value)} (${this.percent(params.value, total)})` } }]
      }, true)

      const buckets = Array.from(new Set(this.trendRows.map(item => item.bucket))).sort()
      const colors = ['#f0584e', '#3689ec', '#f3a52e', '#46bd6c', '#8667df']
      const maxTrend = Math.max.apply(null, this.trendRows.map(item => toNumber(item.repairCount)).concat([1]))
      const trendAxis = axisScale(maxTrend, 4)
      trend.setOption({
        grid: { top: 21, right: 8, bottom: 19, left: 28 },
        tooltip: dashboardTooltip({
          trigger: 'axis',
          formatter: params => {
            const rows = Array.isArray(params) ? params : [params]
            return [rows[0] ? rows[0].axisValue : ''].concat(rows.map(item => `${item.marker}${echarts.format.encodeHTML(item.seriesName)}：${formatNumber(item.value)} 单`)).join('<br/>')
          }
        }),
        xAxis: { type: 'category', data: buckets.map(item => String(item || '').slice(5)), axisLine: { lineStyle: { color: '#315469' } }, axisTick: { show: false }, axisLabel: { color: '#91a7b6', fontSize: 8 } },
        yAxis: { type: 'value', min: 0, max: trendAxis.max, interval: trendAxis.interval, axisLabel: { color: '#91a7b6', fontSize: 8 }, splitLine: { lineStyle: { color: 'rgba(67,121,156,.14)', type: 'dashed' } } },
        series: this.types.map((type, index) => ({
          name: type.name,
          type: 'line',
          data: buckets.map(bucket => {
            const row = this.trendRows.find(item => item.bucket === bucket && item.repairType === type.key)
            return row ? toNumber(row.repairCount) : 0
          }),
          symbolSize: 5,
          lineStyle: { color: colors[index % colors.length] },
          itemStyle: { color: colors[index % colors.length] }
        }))
      }, true)
      this.charts = [bars, trend]
    },
    disposeCharts() {
      this.charts.forEach(chart => chart.dispose())
      this.charts = []
    },
    resizeCharts() { this.charts.forEach(chart => chart.resize()) },
    percent(value, total) { return formatPercent(value, total) }
  }
}
</script>
<style scoped>.repair-type{display:grid;grid-template-columns:57% 43%;height:100%;padding:6px 9px 8px}.repair-type__bars{height:100%}.repair-type__trend{min-width:0;padding-left:12px;border-left:1px solid rgba(65,120,156,.3);color:#aebfca;font-size:10px;text-align:center}.repair-type__line{height:calc(100% - 18px)}</style>
